import React, { useState } from "react";
import styles from "./Career.module.css";
import { Helmet } from "react-helmet-async";
import careerPoster from "../../Assets/Career/career.jpeg";

const Career = () => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.target);

    try {
      const response = await fetch(
        "https://hillgreenhighschool.in/api/career-apply.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (result.success) {
        alert("Application submitted successfully!");
        e.target.reset();
      } else {
        alert("Failed to submit application. Try again.");
      }
    } catch (error) {
      alert("Server error. Please try later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Careers | Hillgreen High School & Junior College</title>
        <meta
          name="description"
          content="Explore current teaching and staff vacancies at Hillgreen High School & Junior College. Apply now."
        />
        <link
          rel="canonical"
          href="https://www.hillgreenhighschool.in/career"
        />
      </Helmet>

      <section className={styles.careerSection}>
        <div className={styles.container}>

          {/* Vacancies Section */}
          <div className={styles.vacanciesCard}>
            <h2>Vacancies – Hillgreen High School & Junior College</h2>

            <div className={styles.posterContainer}>
              <a href={careerPoster} download="Hillgreen_Career_Opportunities.jpeg" className={styles.downloadLink}>
                <img
                  src={careerPoster}
                  alt="Career Opportunities at Hillgreen High School"
                  className={styles.careerImage}
                />
              </a>
              <p className={styles.downloadText}>
                Click on the image to download the vacancy poster.
              </p>
            </div>
          </div>

          {/* Apply Form */}
          <div className={styles.formCard}>
            <h2>Apply for a Job</h2>

            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className={styles.formGroup}>
                <label>Full Name</label>
                <input type="text" name="name" required />
              </div>

              <div className={styles.formGroup}>
                <label>Email</label>
                <input type="email" name="email" required />
              </div>

              <div className={styles.formGroup}>
                <label>Phone Number</label>
                <input type="tel" name="phone" required />
              </div>

              <div className={styles.formGroup}>
                <label>Applying For Position</label>
                <input type="text" name="position" placeholder="e.g. Science Teacher" required />
              </div>

              <div className={styles.formGroup}>
                <label>Upload Resume</label>
                <input type="file" name="resume" required />
              </div>

              <div className={styles.formGroup}>
                <label>Message</label>
                <textarea name="message" rows="4"></textarea>
              </div>

              <button type="submit" disabled={loading}>
                {loading ? "Submitting..." : "Submit Application"}
              </button>
            </form>
          </div>

        </div>
      </section>
    </>
  );
};

export default Career;
